import { render, staticRenderFns } from "./PlanPolygon.vue?vue&type=template&id=6b8e455c"
import script from "./PlanPolygon.vue?vue&type=script&lang=js"
export * from "./PlanPolygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports